<template>
  <section id="infoCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog v-if="active" :active="active" module="reportCalls" @dialog:change="eventdialog"></RangeDateDialog>

    <v-row justify="end" align="center">
      <v-col cols="auto">
        <v-switch class="ml-auto" v-model="activeGraph" inset label="Ver gráficas"></v-switch>
      </v-col>
    </v-row>

    <v-card class="shadow-1">
      <!-- <v-card-text> -->
      <v-tabs v-model="tab" dark background-color="secondary lighten-1" hide-slider grow>
        <v-tab v-for="(item, index) in filteredTabHeaders" :key="index" @click="getCallsInfo(index)">
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in filteredTabHeaders" :key="item">
          <v-card flat>
            <v-container class="px-md-7" fluid v-if="customSearchInfo">
              <v-row dense justify="space-between">
                <v-col cols="12" md="auto">
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Tipo</span>
                    {{
                      customSearchInfo.call == null ? "Todas" : customSearchInfo.call === 1 ? "Salientes" : "Entrantes"
                    }}
                  </span>
                </v-col>

                <v-col cols="12" md="auto">
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Desde</span>
                    {{ customSearchInfo.start }}
                  </span>
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Hasta</span>
                    {{ customSearchInfo.end }}
                  </span>
                </v-col>
              </v-row>
            </v-container>

            <v-divider v-if="customSearchInfo"></v-divider>

            <!-- Tabla -->
            <v-container v-show="!activeGraph">
              <v-skeleton-loader v-if="isLoading" type="table"> </v-skeleton-loader>

              <v-row v-else dense justify="end">
                <v-col cols="12">
                  <vuescroll
                    :ops="{
                      bar: {
                        background: '#bacfcec0',
                        keepShow: true,
                      },
                    }"
                  >
                    <v-data-table
                      :headers="headers"
                      :items="callsInfo"
                      class="elevation-0"
                      :items-per-page="15"
                      hide-default-footer
                      :page.sync="page"
                      @page-count="pageCount = $event"
                    >
                      <!-- <template
                                                        v-slot:[`item.calldate`]="{
                                                            item
                                                        }"
                                                    >
                                                        <span>{{
                                                            item.calldate
                                                                | dateFormat
                                                        }}</span>
                                                    </template> -->
                      <template
                        v-slot:[`item.total`]="{
                          item,
                        }"
                      >
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.total }}
                              <span class="caption grey--text">total</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <span>
                                <v-icon x-small color="teal">mdi-phone</v-icon>
                                {{ item.contestada }}
                              </span>
                              &mdash;
                              <span>
                                <v-icon x-small color="red">mdi-call-missed</v-icon>
                                {{ item.total - item.contestada }}
                              </span>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>

                      <template
                        v-slot:[`item.atencion`]="{
                          item,
                        }"
                      >
                        <span class="d-inline d-md-none pr-2">
                          {{ getAttentionPercentage(item.contestada, item.total) }}
                        </span>

                        <v-progress-circular
                          size="23"
                          :value="getAttentionPercentage(item.contestada, item.total)"
                          color="info"
                        ></v-progress-circular>

                        <span class="d-none d-md-inline pl-2">
                          {{ getAttentionPercentage(item.contestada, item.total) }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.duracion`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.duracion | secondsToTimeFormat }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.maxima`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.maxima | secondsToTimeFormat }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.hablado`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.hablado | secondsToTimeFormat }}
                        </span>
                      </template>
                    </v-data-table>
                  </vuescroll>
                </v-col>
                <v-col cols="auto">
                  <v-pagination circle color="primary" v-model="page" :length="pageCount"></v-pagination>
                </v-col>
              </v-row>
            </v-container>

            <!-- Gráficas -->
            <v-container v-if="activeGraph" fluid>
              <v-row align="center" justify="center">
                <v-col cols="12" md="5" v-if="render && activeGraphDonut">
                  <v-card outlined style="height: inehit;">
                    <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                      Total de llamadas: {{ totalCalls }}
                    </v-card-title>
                    <v-card-text>
                      <apexchart ref="chart5" type="donut" :options="optionsDonut" :series="serieDonut"></apexchart>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col v-else-if="!render && !activeGraphDonut" cols="12" md="5">
                  <v-skeleton-loader transition="scale-transition" class="mx-auto" type="card"> </v-skeleton-loader>
                </v-col>

                <v-col cols="12" md="7">
                  <v-card outlined v-if="render">
                    <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                      Distribución de llamadas por tiempo
                    </v-card-title>
                    <v-card-text>
                      <apexchart ref="chart6" type="line" :options="optionsLine" :series="serieLine"></apexchart>
                    </v-card-text>
                  </v-card>

                  <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="card">
                  </v-skeleton-loader>
                </v-col>

                <v-col v-if="render && activeGraphIncoming" cols="12" md="6">
                  <v-card outlined>
                    <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                      Llamadas entrantes por extensión: {{ totalIncomingCalls }}
                    </v-card-title>
                    <v-card-text>
                      <apexchart
                        ref="chart7"
                        type="bar"
                        :options="optionsBarIncomingCalls"
                        :series="barIncomingCalls"
                      ></apexchart>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col v-else-if="!render && !activeGraphIncoming" cols="12" md="6">
                  <v-skeleton-loader transition="scale-transition" class="mx-auto" type="card"> </v-skeleton-loader>
                </v-col>

                <v-col v-if="render && activeGraphOutgoing" cols="12" md="6">
                  <v-card outlined>
                    <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                      Llamadas salientes por extensión: {{ totalOutgoingCalls }}
                    </v-card-title>
                    <v-card-text>
                      <apexchart
                        ref="chart8"
                        type="bar"
                        :options="optionsBarOutgoingCalls"
                        :series="barOutgoingCalls"
                      ></apexchart>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col v-else-if="!render && !activeGraphOutgoing" cols="12" md="6">
                  <v-skeleton-loader transition="scale-transition" class="mx-auto" type="card"> </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import moment from "moment";

import RangeDateDialog from "../../components/DatePickers/DateRangePicker.vue";

const TODAYDATE = moment().format("YYYY-MM-DD");

export default {
  inject: ["theme"],

  components: {
    RangeDateDialog,
    vuescroll,
  },

  data() {
    return {
      TODAY_DATE: TODAYDATE,
      page: 1,
      pageCount: 1,
      isLoading: false,
      activeGraph: false,
      active: false,
      render: false,
      activeGraphOutgoing: false,
      activeGraphIncoming: false,
      customSearchInfo: null,
      tab: null,
      tabHeaders: ["Día", "Mes", "Año", "Personalizado"],
      headers: [
        { text: "Extensión", value: "extencion", width: "10%" },
        {
          text: "Llamadas",
          align: "right",
          value: "total",
          width: "20%",
        },
        {
          text: "% Atención",
          value: "atencion",
          sortable: false,
          width: "15%",
        },
        {
          text: "Duración",
          align: "right",
          value: "duracion",
          width: "15%",
        },
        {
          text: "T. hablado",
          align: "right",
          value: "hablado",
          width: "15%",
        },
        {
          text: "Llamada máx.",
          align: "right",
          value: "maxima",
          width: "15%",
        },
      ],
      // Table Data
      callsInfo: null,
      // Charts
      chartTab: null,
      chartTabHeaders: ["Gráfica 1", "Gráfica 2", "Gráfica 3"],
      totalCalls: 0,
      totalOutgoingCalls: 0,
      totalIncomingCalls: 0,
      // Opciones chart
      optionsLine: {
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: [],
        },
        colors: ["#FEB019", "#008FFB", "#00E396"],
      },
      optionsDonut: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        labels: ["Entrantes", "Salientes"],
      },
      optionsBarIncomingCalls: {
        xaxis: {
          categories: [],
        },
        fill: {
          //   colors: ["#6D71F9"],
          colors: ["#008FFB"],
        },
      },
      optionsBarOutgoingCalls: {
        xaxis: {
          categories: [],
        },
        fill: {
          colors: ["#00E396"],
          //   colors: ["#FEB019"],
        },
      },
      // Datos chart
      serieDonut: [0, 0],
      serieLine: [
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      barIncomingCalls: [
        {
          name: "Llamadas entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      barOutgoingCalls: [
        {
          name: "Llamadas salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },

    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    filteredTabHeaders() {
      if (this.CurrentRole === 10) return ["Personalizado"];
      return this.tabHeaders;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.getCallsInfo(0);
  },

  // updated() {
  //     this.changeThemeChart();
  // },

  methods: {
    /**
     * [Obtener porcentaje de atención]
     * @param {string} value [llamadas entrantes]
     * @param {string} total [total de llamadas]
     */
    getAttentionPercentage(value, total) {
      let result = (100 * value) / total;

      return result.toFixed() + "%";
    },

    eventdialog(data, parameters) {
      this.active = false;

      if (data !== "cerrar") {
        this.isLoading = false;

        this.customSearchInfo = parameters;
        this.callsInfo = data.all;
        this.graphics(data);
      } else {
        if (this.CurrentRole === 10) {
          this.getCallsInfo(1);
        } else {
          this.tab = 2;
          this.getCallsInfo(2);
        }
      }
    },

    /**
     * [Petición de datos API]
     * @param {number} format [Index de cabecera (Dia, Mes, Año, Personalizado)]
     */
    async getCallsInfo(format) {
      // Activamos loader y ocultamos gráficas (Para búsquedas personalizadas)
      this.render = false;
      this.isLoading = true;
      this.activeGraphDonut = false;
      this.activeGraphIncoming = false;
      this.activeGraphOutgoing = false;

      let request;

      if (this.CurrentRole === 10) {
        // Acceso restringido
        request = format === 0 ? "custom" : "day";
      } else {
        // Acceso completo
        const formatMap = ["day", "mounth", "year", "custom"];
        request = formatMap[format] || "day";
      }

      const accessToken = localStorage.getItem("token");

      if (request === "custom") {
        this.active = true;
      } else {
        this.customSearchInfo = null;

        this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cargando" });
        axios
          .get(`${process.env.VUE_APP_ROOTAPI}/reportCalls/${request}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((res) => {
            this.callsInfo = res.data.all;
            this.graphics(res.data);
          })
          .catch((error) => {
            console.error(error);
            this.$snotify.error("Hubo un error en la consulta.", "Error");
          })
          .finally(() => {
            this.isLoading = false;
            this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
          });
      }
    },

    graphics(response) {
      // Gráfica de lineas (Distribución de llamadas por tiempo)
      this.optionsLine.xaxis.categories = response.graph3H;
      this.serieLine[0].data = response.graph3C;
      this.serieLine[2].data = response.graph3A;
      this.serieLine[1].data = response.graph3B;

      // Gráfica de llamadas entrantes
      if (response.graph2Starters.data !== null) {
        this.optionsBarIncomingCalls.xaxis.categories = response.graph2Starters.data.map(function(value) {
          return value.extension;
        });
        this.barIncomingCalls[0].data = response.graph2Starters.data.map(function(value) {
          return value.total;
        });

        this.activeGraphIncoming = true;
      }

      // Gráfica de llamadas salientes
      if (response.graph2Outgoing.data !== null) {
        this.optionsBarOutgoingCalls.xaxis.categories = response.graph2Outgoing.data.map(function(value) {
          return value.extension;
        });
        this.barOutgoingCalls[0].data = response.graph2Outgoing.data.map(function(value) {
          return value.total;
        });

        this.activeGraphOutgoing = true;
      }

      // Gráfica de donut (Total de llamadas)
      if (response.starters !== null && response.outgoing !== null) {
        this.totalCalls = response.starters + response.outgoing;
        this.totalIncomingCalls = response.starters;
        this.totalOutgoingCalls = response.outgoing;
        this.serieDonut = [response.starters, response.outgoing];
        this.activeGraphDonut = true;
      }

      // Renderizamos al final la gráfica luego de pintar datos
      this.render = true;
    },

    // changeThemeChart() {
    //     if (this.isDark) {
    //         this.$refs.chart1IncomingCalls[0].updateOptions(
    //             { theme: { mode: "dark" } },
    //             true
    //         );
    //         this.$refs.chart2IncomingCalls[0].updateOptions(
    //             { theme: { mode: "dark" } },
    //             true
    //         );
    //         this.$refs.chart3IncomingCalls[0].updateOptions(
    //             { theme: { mode: "dark" } },
    //             true
    //         );
    //     } else {
    //         this.$refs.chart1IncomingCalls[0].updateOptions(
    //             { theme: { mode: "light" } },
    //             true
    //         );
    //         this.$refs.chart2IncomingCalls[0].updateOptions(
    //             { theme: { mode: "light" } },
    //             true
    //         );
    //         this.$refs.chart3IncomingCalls[0].updateOptions(
    //             { theme: { mode: "light" } },
    //             true
    //         );
    //     }
    // }
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}
</style>
